<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <!-- Custom multi-select wrapper -->
  <div
    #multiSelectWrapper
    class="is-multi-select"
    [class.is-multi-select--open]="isOpen"
    [class.is-multi-select--disabled]="isDisabled"
    [class.is-multi-select--error]="hasError"
  >
    <!-- Trigger -->
    <div
      class="is-multi-select__trigger"
      role="combobox"
      tabindex="0"
      [attr.aria-expanded]="isOpen"
      (click)="toggle()"
      (keydown)="onKeydown($event)"
    >
      <!-- Chips -->
      <div class="is-multi-select__chips" *ngIf="selectedOptions.length > 0">
        <span *ngFor="let opt of selectedOptions" class="is-multi-select__chip">
          {{ opt.label }}
          <button type="button" class="is-multi-select__chip-remove" (click)="removeChip(opt.value, $event)">
            <i class="bx bx-x"></i>
          </button>
        </span>
      </div>

      <!-- Placeholder -->
      <span *ngIf="selectedOptions.length === 0" class="is-multi-select__placeholder">
        {{ placeholder }}
      </span>

      <!-- Icons -->
      <div class="is-multi-select__icons">
        <span *ngIf="selectedValues.length > 0" class="is-multi-select__count badge bg-primary bg-opacity-10 text-primary">
          {{ selectedValues.length }}
        </span>
        <button
          *ngIf="selectedValues.length > 0 && !isDisabled"
          type="button"
          class="is-multi-select__clear"
          (click)="clearAll($event)"
          [attr.aria-label]="'IS_LIB.CLEAR' | translate"
        >
          <i class="bx bx-x"></i>
        </button>
        <i class="bx bx-chevron-down is-multi-select__arrow"></i>
      </div>
    </div>

    <!-- Dropdown -->
    <div *ngIf="isOpen" class="is-multi-select__dropdown">
      <!-- Search -->
      <div class="is-multi-select__search">
        <i class="bx bx-search is-multi-select__search-icon"></i>
        <input
          #searchInput
          type="text"
          class="is-multi-select__search-input"
          [placeholder]="'IS_LIB.SEARCH_PLACEHOLDER' | translate"
          [(ngModel)]="searchTerm"
          (input)="filterOptions()"
          (keydown)="onSearchKeydown($event)"
        >
      </div>

      <!-- Options -->
      <ul class="is-multi-select__options" role="listbox">
        <li
          *ngFor="let opt of filteredOptions; let i = index"
          class="is-multi-select__option"
          [class.is-multi-select__option--selected]="isSelected(opt.value)"
          [class.is-multi-select__option--highlighted]="i === highlightedIndex"
          [class.is-multi-select__option--disabled]="opt.disabled || (isMaxReached && !isSelected(opt.value))"
          role="option"
          (click)="toggleOption(opt)"
          (mouseenter)="highlightedIndex = i"
        >
          <div class="is-multi-select__checkbox">
            <i [class]="isSelected(opt.value) ? 'bx bx-checkbox-checked' : 'bx bx-checkbox'"></i>
          </div>
          <span>{{ opt.label }}</span>
        </li>

        <!-- Empty -->
        <li *ngIf="filteredOptions.length === 0" class="is-multi-select__empty">
          {{ 'IS_LIB.NO_RECORDS' | translate }}
        </li>
      </ul>
    </div>
  </div>

  <small *ngIf="helpText && !hasError" class="form-text text-muted">{{ helpText }}</small>
  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
